import "./responsive_namespace.js";

if (!Sparkle?.Responsive?.mediaCheck) {
  Sparkle.Responsive.mediaCheck = class mediaCheck {
    static enabled = true;

    static {
      // GETTERS
      Object.defineProperty(this.prototype, "matches", {
        get() {
          return this.mq.matches;
        },
      });
    }

    static disable() {
      return (this.enabled = false);
    }

    static enable() {
      return (this.enabled = true);
    }

    constructor(options) {
      this.addListener = this.addListener.bind(this);
      this.teardown = this.teardown.bind(this);
      this.mqChange = this.mqChange.bind(this);
      this.mqEntry = this.mqEntry.bind(this);
      this.mqExit = this.mqExit.bind(this);
      this.options = options;
      this.listeners = [];

      if (window.matchMedia !== undefined) {
        this.mq = window.matchMedia(this.options.media);
        this.addListener(this.mqChange);
        if (this.mq.matches) {
          this.mqEntry();
        }
      }
    }

    addListener(fn) {
      const listener = () => {
        if (this.constructor.enabled) {
          return fn(this.mq.matches);
        }
      };
      this.listeners.push(listener);
      return this.mq.addEventListener("change", listener);
    }

    teardown() {
      return this.listeners.forEach((listener) => this.mq.removeEventListener("change", listener));
    }

    mqChange(match) {
      if (match) {
        return this.mqEntry();
      } else {
        return this.mqExit();
      }
    }

    mqEntry() {
      if (typeof this.options.entry === "function") {
        return this.options.entry();
      }
    }

    mqExit() {
      if (typeof this.options.exit === "function") {
        return this.options.exit();
      }
    }
  };
}
